export function InfoIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="13"
      focusable="false"
      viewBox="0 0 16 16"
    >
      <g stroke="currentColor">
        <circle cx="7.5" cy="8.5" r="7" fill="none" />
        <path strokeLinecap="round" d="M7.5 12.5V8" />
      </g>
      <circle cx="7.5" cy="5" r="1" fill="currentColor" />
    </svg>
  );
}
